/**
 * Unique Diamonds — Mega menu hover behaviour
 * ----------------------------------------------------------------------------
 * Dawn's <details> elements open only on click by default. This script opens
 * them on hover (desktop only) and closes them when the mouse leaves both the
 * summary and the mega-menu content, with a small grace delay so the cursor
 * can travel across the gap without the panel snapping shut.
 *
 * Mobile/tablet behaviour is left untouched — users still tap to open, which
 * is the correct pattern for touch devices.
 *
 * Include this script at the end of <body>, or defer-load it from the theme
 * layout:   <script src="{{ 'mega-menu-hover.js' | asset_url }}" defer></script>
 */
(function () {
  'use strict';

  // Only run hover behaviour on pointer:fine devices (mouse, trackpad).
  // Touch devices fall back to the default click behaviour.
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (!window.matchMedia('(min-width: 990px)').matches) return;

  var CLOSE_DELAY = 350; // ms — grace for cursor travel from summary to panel
  var closeTimer = null;

  var megaMenus = document.querySelectorAll('header-menu > details.mega-menu');

  megaMenus.forEach(function (details) {
    var summary = details.querySelector(':scope > summary');
    if (!summary) return;

    function openMenu() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      // Close any other mega menus that may be open
      megaMenus.forEach(function (other) {
        if (other !== details && other.hasAttribute('open')) {
          other.removeAttribute('open');
          var otherSummary = other.querySelector(':scope > summary');
          if (otherSummary) otherSummary.setAttribute('aria-expanded', 'false');
        }
      });
      if (!details.hasAttribute('open')) {
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      }
      // UD: add class to header-wrapper so icons turn dark (fallback for no :has())
      var headerWrapper = document.querySelector('.header-wrapper');
      if (headerWrapper) headerWrapper.classList.add('has-mega-open');
    }

    function scheduleClose() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        if (details.hasAttribute('open')) {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }
        // UD: remove class only if no other mega menu still open
        var anyOpen = false;
        megaMenus.forEach(function (m) { if (m.hasAttribute('open')) anyOpen = true; });
        if (!anyOpen) {
          var headerWrapper = document.querySelector('.header-wrapper');
          if (headerWrapper) headerWrapper.classList.remove('has-mega-open');
        }
        closeTimer = null;
      }, CLOSE_DELAY);
    }

    // Open on mouse enter of summary
    summary.addEventListener('mouseenter', openMenu);
    // Also open if cursor enters the mega panel directly (edge case)
    details.addEventListener('mouseenter', openMenu);
    // Close when cursor leaves the whole <details> (summary + panel)
    details.addEventListener('mouseleave', scheduleClose);

    // Keep the original click-to-toggle working for keyboard users and
    // as a fallback. We don't interfere with Dawn's native handlers.
  });

  // Close any open mega menu if user tabs/clicks outside the header
  document.addEventListener('click', function (e) {
    var insideHeader = e.target.closest('header-menu, .header');
    if (!insideHeader) {
      megaMenus.forEach(function (details) {
        if (details.hasAttribute('open')) {
          details.removeAttribute('open');
          var s = details.querySelector(':scope > summary');
          if (s) s.setAttribute('aria-expanded', 'false');
        }
      });
    }
  });
})();
